<template>
    <nav class="l-nav">

        <span class="o-shape-circle | bg-pink | --l-5 --b10 u-dn@md"></span>
        <img src="~assets/img/layout/deco/rain.png" alt="Decoration" class="o-deco | u-img | --b5 --l-5 --w30 u-dn@md">
        <img src="~assets/img/layout/deco/pepper.png" alt="Decoration" class="o-deco | u-img | --t5 --r-10 --w25 u-dn@md">

        <ul class="l-nav__list">
            <li class="l-nav__item">
                <router-link to="/fr/menu" class="l-nav__link | c-btn c-btn--stroke c-btn--rounded">
                    <span class="c-btn__label">Menus</span>
                </router-link>
            </li>
            <li class="l-nav__item">
                <router-link to="/fr/mission" class="l-nav__link">
                    <span class="c-btn__label">Mission</span>
                </router-link>
            </li>
            <li class="l-nav__item">
                <router-link to="/fr/contact" class="l-nav__link">
                    <span class="c-btn__label">Contact</span>
                </router-link>
            </li>
        </ul>

        <a :href="instagramProfile" :title="`${siteName} sur Instagram`" class="l-nav__instagram">
            <Icon icon="instagram" />
        </a>
    </nav>
</template>

<script>/* eslint-disable */

    import Icon from 'components/Icon'

    export default {
        name: 'AppNav',
        components: {
            Icon
        },
        props: {
            isOpen: {
                type: Boolean,
                default: false
            }
        },
        computed: {

            site()  {

                if ( !this.$store.state.site.site )
                    return

                return this.$store.state.site.site

            },
            siteName() {

                if ( !this.site )
                    return

                return this.site.settings.site_name

            },
            instagramProfile() {

                if ( !this.site )
                    return

                const instagram = this.site.restaurant.accounts.find(account => account.name === 'instagram')

                return instagram.url

            }
        }
    }
</script>

<style scoped>
</style>
